// removed by extract-text-webpack-plugin
module.exports = {"container":"DesktopQuestionDefinitionView__container___3OI_-"};